<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import ReadMoreIndowStories from '$lib/PageSections/ReadMoreIndowStories/ReadMoreIndowStories.svelte';

	import SectionCaseStudies from './Sections/CaseStudies/SectionCaseStudies.svelte';
</script>

<Section backgroundColor={'white'}>
	<p>
		Helping people find comfort, quiet and savings is what we do. But instead of
		relying on our word, read what our customers have to say about window insert
		projects that improved their quality of life. We conducted interviews to
		understand the challenges they faced, and how Indow inserts helped. Also, we
		encourage every customer to <a href="/resources/customer-reviews/"
			>leave a review with an independent third party</a
		>. Read some of those window insert examples below, or scroll to the bottom
		to see all our Indow case studies by category.
	</p>
	<hr />
	<SectionCaseStudies />
	<hr />
</Section>
<ReadMoreIndowStories />
<GetAFreeEstimate backgroundColor={'grey'} />
<FeaturedArticles />
